<template>
  <div>
    <v-card class="mt-4">
      <v-toolbar text color="primary" dark class="justify-center">
        <v-toolbar-title>{{ value.title }}</v-toolbar-title>
        <v-spacer/>
        <v-switch
            v-model="value.active"
            color="secondary"
            :label="value.active ? 'فعال' : 'غیرفعال'"
            @change="change_active"
            hide-details
        >
        </v-switch>

      </v-toolbar>
      <v-card-text>
        <v-row v-for="(field,index) in value.fields" :key="index">
          <FieldEditable v-model="value.fields[index]"/>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn color="accent" :disabled="!value.active" block @click="$store.commit('open_create_field_dialog', value.id)">
          اضافه کردن فیلد جدید
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import {mapState} from "vuex";
import FieldEditable from "./FieldEditable";

export default {
  name: "SettingEditable",
  components: {FieldEditable},
  computed: {
    ...mapState({
      dialog_field_creation: state => state.Admin.settings.create_field_dialog.show,
      loading: state => state.Admin.settings.loading
    }),
  },
  data() {
    return {
      switch_active: true,
      value: {
        title: "",
        fields: [
          {
            name: "",
            type: "",
            value: ""
          }
        ]
      },
    }
  },
  props: {
    value: {
      type: Object,
    }
  },
  methods:{
    change_active(new_value){
      this.$store.dispatch('update_main_setting', {id: this.value.id, value: new_value})
    }
  }
}
</script>

<style scoped>

</style>
